export const STREAM_STATUS_STOPPED = 'STOPPED';
